import { nanoid } from 'nanoid'

import { SCIM_STATES, USER_PROVISIONING_STEPS } from './constants'

const sortAttrValuesFn = (attrValueA, attrValueB) => {
  if (attrValueA.toLowerCase() > attrValueB.toLowerCase()) {
    return 1
  }
  if (attrValueA.toLowerCase() < attrValueB.toLowerCase()) {
    return -1
  }

  return 0
}

export const calculateStep = (payload) => {
  if (payload?.state === SCIM_STATES.ENABLED) {
    return USER_PROVISIONING_STEPS.GROUP_MAPPING
  }
  return USER_PROVISIONING_STEPS.SCIM_PROVISIONING
}

export const emptyMapping = () => ({
  key: nanoid(5),
  attrValue: '',
  groupId: ''
})

export const generateEmptyMappings = (count) => (
  Array.from(
    { length: count },
    () => emptyMapping()
  )
)

export const mapAttributeValues = ({ attributeValues, groupMappings }, newValues) => {
  const attributeValueMap = new Map(attributeValues.map((attributeValue) => [attributeValue.name, attributeValue.id]))
  const usedAttributeValueMap = new Map(groupMappings.map((groupMapping) => [groupMapping.attribute_value, true]))

  const attributeValueSet = new Set([
    ...attributeValues.map((attributeValue) => attributeValue.name),
    ...newValues
  ])

  const newAttrValueCollection = [...attributeValueSet]
    .sort(sortAttrValuesFn)
    .map((attributeValue) => ({
      id: attributeValueMap.get(attributeValue) || nanoid(10),
      name: attributeValue,
      isUsed: !!usedAttributeValueMap.get(attributeValue)
    }))

  return [...newAttrValueCollection]
}

export const transformGroupMappings = (mappings) => (
  mappings.filter(
    ({ attrValue, groupId }) => Boolean(attrValue) || Boolean(groupId)
  ).map(
    ({ id, attrValue, groupId, isBeingDeleted }) => (
      {
        id,
        _destroy: isBeingDeleted,
        attribute_value: attrValue,
        user_group_id: groupId,
      }
    )
  )
)
